import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityUsage } from '@api/data-security/getDataSecurityUsage';

export const getCoreDataSecurityUsageSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityUsage',
	receive: true,
	request: true,
	requestHandler: getDataSecurityUsage,
	retainDataOnRequest: true
});
